import type { GetApiCoursesCourseIdLecturesLectureId200ContentType } from './getApiCoursesCourseIdLecturesLectureId200ContentType';
import type { GetApiCoursesCourseIdLecturesLectureId200ResourcesItem } from './getApiCoursesCourseIdLecturesLectureId200ResourcesItem';

/**
 * 강의 세부 정보 조회 성공 응답
 */
export type GetApiCoursesCourseIdLecturesLectureId200 = {
  /** 강의 내용 (마크다운) */
  content?: string;
  /** 콘텐츠 유형 */
  contentType: GetApiCoursesCourseIdLecturesLectureId200ContentType;
  /** 생성 시간 */
  createdAt?: string;
  /**
   * 강의 길이 (분)
   * @nullable
   */
  duration?: number | null;
  /** 강의 ID */
  id: string;
  /** 완료 여부 */
  isCompleted?: boolean;
  /** 강의 자료 */
  resources?: GetApiCoursesCourseIdLecturesLectureId200ResourcesItem[];
  /** 강의 제목 */
  title: string;
  /** 수정 시간 */
  updatedAt?: string;
  /**
   * 비디오 URL
   * @nullable
   */
  videoUrl?: string | null;
};
